// eslint-disable-next-line no-restricted-imports
import mixpanel from 'mixpanel-browser'
import { env } from 'utils/environment'

export function mixpanelWithCatch(mixpanelFn: (_mixpanel: typeof mixpanel) => void) {
    try {
        return mixpanelFn(mixpanel)
    } catch (error) {
        // no op, it's too noisy to log this
    }
}

export function mixpanelInit() {
    if (!env.VITE_MIXPANEL_TOKEN) {
        return
    }

    try {
        mixpanel.init(env.VITE_MIXPANEL_TOKEN, {
            debug: env.DEV,
            ignore_dnt: true, // do we want this? ignore do not track?
            persistence: 'localStorage',
        })
    } catch (error) {
        console.warn('[mixpanel] mixpanel error (likely not initialized):', error)
    }
}
